// Haustechnik – zentrale Labels, Farben und Reihenfolgen.

// Auftragstypen
export const ORDER_TYPE_LABELS = {
  schaden: 'Schaden/Reparatur',
  renovierung: 'Renovierung',
  transport: 'Transport',
  besorgung: 'Besorgung',
  wartung: 'Wartung',
  sonstiges: 'Sonstiges',
};

export const ORDER_TYPE_ORDER = ['schaden', 'renovierung', 'transport', 'besorgung', 'wartung', 'sonstiges'];

export const RECURRENCE_LABELS = {
  none: 'Einmalig',
  weekly: 'Wöchentlich',
  monthly: 'Monatlich',
  quarterly: 'Vierteljährlich',
  yearly: 'Jährlich',
};

// Typ-spezifische Zusatzfelder (werden in `details` gespeichert)
export const TYPE_FIELDS = {
  transport: [
    { key: 'from', label: 'Von', type: 'text', placeholder: 'Abholort' },
    { key: 'to', label: 'Nach', type: 'text', placeholder: 'Zielort' },
    { key: 'vehicle', label: 'Fahrzeug', type: 'text', placeholder: 'z. B. Sprinter, Anhänger' },
  ],
  besorgung: [
    { key: 'items', label: 'Einkaufsliste', type: 'textarea', placeholder: 'Was soll besorgt werden?' },
    { key: 'budget', label: 'Budget (€)', type: 'number' },
    { key: 'shop', label: 'Geschäft / Ort', type: 'text' },
  ],
  renovierung: [
    { key: 'scope', label: 'Umfang / Gewerke', type: 'textarea', placeholder: 'z. B. Streichen, Boden, Elektrik' },
  ],
  wartung: [
    { key: 'recurrence', label: 'Wiederholung', type: 'select', options: ['none', 'weekly', 'monthly', 'quarterly', 'yearly'] },
  ],
};

export const CATEGORY_LABELS = {
  elektrik: 'Elektrik',
  sanitaer: 'Sanitär',
  heizung: 'Heizung/Klima',
  moebel: 'Möbel',
  it: 'IT/Technik',
  aussenanlage: 'Außenanlage',
  sonstiges: 'Sonstiges',
};

export const URGENCY_LABELS = {
  low: 'Niedrig',
  medium: 'Mittel',
  high: 'Hoch',
  danger: 'Gefahr',
};

export const URGENCY_STYLES = {
  low: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  medium: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  high: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  danger: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
};

export const STATUS_LABELS = {
  reported: 'Gemeldet',
  approved: 'Freigegeben',
  rejected: 'Abgelehnt',
  quote_requested: 'Angebot angefordert',
  in_progress: 'In Arbeit',
  done: 'Erledigt',
};

export const STATUS_STYLES = {
  reported: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  approved: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  rejected: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  quote_requested: 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300',
  in_progress: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  done: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
};

// Board-Spalten (Reihenfolge)
export const BOARD_COLUMNS = ['reported', 'approved', 'quote_requested', 'in_progress', 'done'];

export const fmtDateTimeDe = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('de-DE', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch { return iso; }
};

export const fmtDateDe = (iso) => {
  if (!iso) return '';
  try { return new Date(String(iso).slice(0, 10)).toLocaleDateString('de-DE'); } catch { return iso; }
};
